module.exports = __webpack_public_path__ + "img/electric_no_zone.ed82b78a.svg";